import { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, TOKEN_KEY } from "@/api/client";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [admin, setAdmin] = useState(() => {
    const raw = localStorage.getItem("tkh_admin");
    return raw ? JSON.parse(raw) : null;
  });

  const doLogin = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem("tkh_admin", JSON.stringify(data.admin));
    setToken(data.access_token);
    setAdmin(data.admin);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("tkh_admin");
    setToken(null);
    setAdmin(null);
  };

  const markPasswordChanged = () => {
    setAdmin((prev) => {
      const next = { ...prev, must_change_password: false };
      localStorage.setItem("tkh_admin", JSON.stringify(next));
      return next;
    });
  };

  useEffect(() => {
    const onUnauth = () => logout();
    window.addEventListener("tkh-unauthorized", onUnauth);
    return () => window.removeEventListener("tkh-unauthorized", onUnauth);
  }, []);

  return (
    <AdminAuthContext.Provider
      value={{
        token,
        admin,
        isAuthed: !!token,
        mustChange: !!admin?.must_change_password,
        login: doLogin,
        logout,
        markPasswordChanged,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
